export const environment = {
  production: false,
  host:"https://api.myredlabs.be/api/",
  url:"https://api.myredlabs.be",
};